import { SAMPLE_RELATED_CONTACTS } from './sampleRelatedContacts';
import type { AccountRelatedContact } from './types';

// Same shape as the other Account list hooks, so wiring svc-contracting only replaces this body.
export function useAccountRelatedContacts(_accountId: string): {
  error: Error | null;
  isLoading: boolean;
  relatedContacts: ReadonlyArray<AccountRelatedContact>;
} {
  return { error: null, isLoading: false, relatedContacts: SAMPLE_RELATED_CONTACTS };
}
